import GameVersion, {
  GameVersionCapability,
  gameVersionHas,
} from 'app/frontend/types/custom/GameVersion'

const notificationTemplateCapabilities: Record<string, GameVersionCapability> =
  {
    'candidate-update': 'guild_candidates',
    'character-gear': 'blizzard_api',
    'character-left-guild': 'blizzard_api',
    'character-missing': 'blizzard_api',
    'character-vault-options': 'great_vault',
    'character-crests-not-capped': 'crests',
    'wishlist-missing': 'loot',
    'wishlist-missing-summary': 'loot',
    'wishlist-update': 'loot',
  }

export const notificationTemplateVisibleForGameVersion = (
  key: string,
  gameVersion: GameVersion,
): boolean => {
  const capability = notificationTemplateCapabilities[key]
  return !capability || gameVersionHas(capability, gameVersion)
}
